import React, { useState } from "react";
import { Grid, styled, TextField, ThemeProvider } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ReactComponent as CalenderIcon } from "../../assets/CalenderIcon.svg";
import Toast from "../../components/ToastContainer/CustomToast";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { createTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { es, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

const MuiTheme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: process.env.REACT_APP_BG_ICON,
    },
    secondary: {
      main: "#f50057",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  cssLabel: {
    color: "#0000008a",
  },

  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: "#1976d2 !important",
    },
  },
  cssFocused: {
    color: "#1976d2 !important",
  },

  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#C4C4C4 !important",
  },
  dialogbox: {
    "& .css-hlj6pa-MuiDialogActions-root": {
      marginLeft: "290px !important",
    },
    "& .css-ypiqx9-MuiDialogContent-root": {
      padding: "0px !important",
    },
  },
}));

export default function CustomDatePicker(props) {
  const classes = useStyles();
  const [dateOpen, setDateOpen] = useState(false);
  const { t } = useTranslation();
  const [scheduledStartDate, setScheduledStartDate] = React.useState(
    new Date()
  );

  const handleDate = (e) => {
    setScheduledStartDate(e);
    props.SelectedDate(e);
  };

  const onKeyDown = (e) => {
    e.preventDefault();
    Toast(t("INVITESTARTDATEERROR3"), "error");
  };

  return (
    <>
      {props.label === "Fecha mensual" ? (
        <ThemeProvider theme={MuiTheme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <DesktopDatePicker
              disabled={props.disabled}
              hideTabs={false}
              components={{
                OpenPickerIcon: CalenderIcon,
              }}
              dateRangeIcon={<CalenderIcon />}
              label={
                <span>
                  {props.label} <span style={{ color: "red" }}>*</span>
                </span>
              }
              disablePast={props.disablePast}
              disableFuture={props.disableFuture}
              onChange={props.onChange}
              onChangeText={props.onChangeText}
              inputFormat={props.date}
              value={props.value}
              minDateTime={props.minDateTime}
              type="datetime-local"
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              renderInput={(params) => (
                <TextField
                  onKeyDown={onKeyDown}
                  style={{ width: "-webkit-fill-available" }}
                  {...params}
                  InputLabelProps={{
                    classes: {
                      root: classes.cssLabel,
                      focused: classes.cssFocused,
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </ThemeProvider>
      ) : (
        <ThemeProvider theme={MuiTheme}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={enUS}
          >
            <DesktopDatePicker
              disabled={props.disabled}
              hideTabs={false}
              components={{
                OpenPickerIcon: CalenderIcon,
              }}
              dateRangeIcon={<CalenderIcon />}
              label={props.label}
              disablePast={props.disablePast}
              disableFuture={props.disableFuture}
              onChange={props.onChange}
              onChangeText={props.onChangeText}
              inputFormat={props.date}
              value={props.value}
              minDateTime={props.minDateTime}
              type="datetime-local"
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              renderInput={(params) => (
                <TextField
                  onKeyDown={onKeyDown}
                  style={{ width: "-webkit-fill-available" }}
                  {...params}
                  InputLabelProps={{
                    classes: {
                      root: classes.cssLabel,
                      focused: classes.cssFocused,
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </ThemeProvider>
      )}
    </>
  );
}
